function isEditorPathname(pathname: string): boolean {
  return pathname.startsWith('/p/')
}

let reloadInFlight = false

export function getInitialDocumentPathname(): string | null {
  if (typeof window === 'undefined' || typeof performance === 'undefined') return null

  const [navigationEntry] = performance.getEntriesByType('navigation')
  if (!navigationEntry?.name) return null

  try {
    return new URL(navigationEntry.name).pathname
  } catch {
    return null
  }
}

export function crossesEditorDocumentPolicy(initialPathname: string | null, currentPathname: string): boolean {
  if (!initialPathname) return false
  return isEditorPathname(initialPathname) !== isEditorPathname(currentPathname)
}

/**
 * Editor documents receive a distinct CSP plus COOP/COEP headers. Those
 * policies belong to the document and do not change during a Next.js client
 * navigation, so crossing the `/p/...` boundary requires a real navigation.
 */
export function reloadForEditorDocumentPolicy(currentPathname: string): boolean {
  if (typeof window === 'undefined') return false
  if (!crossesEditorDocumentPolicy(getInitialDocumentPathname(), currentPathname)) return false
  if (reloadInFlight) return true

  reloadInFlight = true
  window.location.reload()
  return true
}
